/**
 * Telemetry utility for onboarding and feature tracking
 * Wraps the existing analytics track function with onboarding-specific events
 */
import { track } from '@/lib/analytics';

/**
 * Track onboarding events
 */
export function trackOnboardingEvent(
  event: 'onboarding:started' | 'onboarding:step_shown' | 'onboarding:completed' | 'onboarding:dismissed',
  props?: Record<string, any>
): void {
  try {
    track(event as any, {
      variant: 'v1',
      ...props,
    } as any);
  } catch (err) {
    // Silently fail if analytics is disabled or errors
    console.debug('[telemetry] Failed to track onboarding event', event, err);
  }
}

/**
 * Track render funnel events
 */
export function trackRenderEvent(
  event: 'render:started' | 'render:phase_changed' | 'render:completed',
  props?: Record<string, any>
): void {
  try {
    track(event as any, props as any);
  } catch (err) {
    console.debug('[telemetry] Failed to track render event', event, err);
  }
}

/**
 * Track CTA clicks
 */
export function trackCTAClick(
  action: 'share' | 'download' | 'add_multipanel',
  props?: Record<string, any>
): void {
  try {
    track(`cta:${action}_clicked` as any, props as any);
  } catch (err) {
    console.debug('[telemetry] Failed to track CTA click', action, err);
  }
}

/**
 * Generic track function for any event
 */
export function trackEvent(event: string, props?: Record<string, any>): void {
  try {
    track(event as any, props as any);
  } catch (err) {
    console.debug('[telemetry] Failed to track event', event, err);
  }
}








